import { urlEncode } from '@services/Url';

const serializeFormData = data => ({
  contentGuidString: data.contentGuidString,
  title: data.title,
  summary: data.summary,
  billNumber: data.billNumber,
  ctaLabel: data.ctaLabel,
  ctaUrl: data.ctaUrl,
  effectiveDate: data.effectiveDate,
  addedDate: data.addedDate,
  createdDate: data.createdDate,
  createdBy: data.createdBy,
});

const eBarEnactmentsCreate = async (data) => {
  const eBarCreate = await fetch('/EBarEnactmentsCallToActionBlock/CreateEpiEnactments', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    body: urlEncode({
      input: JSON.stringify(serializeFormData(data)),
    }),
  });
  const eBarCreateJson = eBarCreate.json();

  return eBarCreateJson;
};

const eBarEnactmentsUpdate = async (data) => {
  const eBarUpdate = await fetch('/EBarEnactmentsCallToActionBlock/UpdateEpiEnactments', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    body: urlEncode({
      input: JSON.stringify(serializeFormData(data)),
    }),
  });
  const eBarUpdateJson = eBarUpdate.json();

  return eBarUpdateJson;
};

const eBarEnactmentsDelete = async (data) => {
  const eBarDelete = await fetch('/EBarEnactmentsCallToActionBlock/DeleteEpiEnactments', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    body: urlEncode({
      stringToDelete: data,
    }),
  });
  const eBarDeleteJson = eBarDelete.json();

  return eBarDeleteJson;
};


export {
  eBarEnactmentsCreate,
  eBarEnactmentsUpdate,
  eBarEnactmentsDelete,
};
